module.exports = __webpack_public_path__ + "static/media/forwardArrowDisabled.f4336c04.svg";